import React from 'react';
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  TextInput,
  TextField,
  NumberInput,
  translate as t,
} from 'admin-on-rest';

import Edit from '../components/Edit';
import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';
import TranslatableInput from '../components/inputs/TranslatableInput';
import TranslatableField from '../components/fields/TranslatableField';
import { getTranslationByLocale } from '../utils/TranslationUtils';
import ImageInput from '../components/inputs/ImageInput';
import ThumbnailImageField from '../components/fields/ThumbnailImageField';

export const MarketList = (props) => (
  <List {...props}>
    <Datagrid>
      <TranslatableField source="title" {...props} />
      <TextField source="countryCode" />
      <EditButton {...props} basePath="/markets" />
      <DeleteButton {...props} basePath="/markets" />
    </Datagrid>
  </List>
);

const MarketTitle = t(({ record, translate, locale }) => (
  <span>{record ? translate('edit.title', { title: getTranslationByLocale(record.title, locale) }) : ''}</span>
));

function editCreateForm(props) {
  return (
    <SimpleForm redirect="list">
      <TranslatableInput source="title" {...props} />
      <TextInput source="countryCode" />
      <TextInput source="languageCodes" />
      <TextInput source="currencyCode" />
      <NumberInput source="currencyPrecision" />
      <NumberInput source="alcoholAgeLimit" />
      <TextInput source="instagram" options={{ fullWidth: true }} />
      <TextInput source="facebook" options={{ fullWidth: true }} />
      <TextInput source="jobApplication" options={{ fullWidth: true }} />
      <ImageInput source="shareImage" accept="image/*">
        <ThumbnailImageField source="src" />
      </ImageInput>
      <TextInput source="domain" options={{ fullWidth: true }} />
      <TextInput source="androidLink" options={{ fullWidth: true }} />
      <TextInput source="iosLink" options={{ fullWidth: true }} />
      <TextInput source="facebookPixelKey" options={{ fullWidth: true }} />
      <TextInput source="googleAnalyticsKey" options={{ fullWidth: true }} />
      <TextInput source="gtmKey" options={{ fullWidth: true }} />
      <TextInput source="giftcardTemplateId" options={{ fullWidth: true }} />
      <TextInput source="editorialV2" options={{ fullWidth: true }} />
    </SimpleForm>
  );
}

export const MarketEdit = (props) => (
  <Edit title={<MarketTitle />} {...props}>
    {editCreateForm(props)}
  </Edit>
);

export const MarketCreate = (props) => (
  <Create {...props}>
    {editCreateForm(props)}
  </Create>
);
